module.exports = __webpack_public_path__ + "static/media/sinon 7.30b35cfd.png";